import React from "react"
import ErrorPage from "../ErrorPage"
import { SYSTEM_UPDATE } from "../constants"

const SystemUpdate = () => {
  return <ErrorPage data={SYSTEM_UPDATE} />
}

export default SystemUpdate
